//
//
//
//
//
//

export default {
  name: "showHeader-editor",
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  }
};